import * as React from "react"
import { Box, Link as MuiLink } from "@mui/material"
import {
  HiOutlineUserCircle,
  HiMenuAlt4,
  HiOutlineCollection,
  HiOutlineFingerPrint,
} from "react-icons/hi"
import Link from "next/link"
import { useRouter } from "next/router"

import Logo from "components/Logo"

export default function DashboardMobileNav() {
  return (
    <Box
      component="nav"
      sx={{
        display: { xs: "flex", sm: "none" },
        displayPrint: "none",
        position: "fixed",
        width: "100%",
        bottom: 0,
        zIndex: 5,
        bgcolor: "background.paper",
        borderTopColor: "gray.300",
        borderTopWidth: 1,
        borderTopStyle: "solid",
        paddingBottom: `env(safe-area-inset-bottom, 0.5rem)`,
      }}
    >
      <Box
        component="ul"
        sx={{
          listStyle: "none",
          display: "grid",
          gridTemplateColumns: "repeat(5, 1fr)",
          marginBlock: 0,
          paddingInline: 0,
          width: "100%",
          "& > li:nth-child(n+2)": {
            borderLeftColor: "gray.300",
            borderLeftWidth: 1,
            borderLeftStyle: "solid",
          },
        }}
      >
        <MobileNavItem href={{ pathname: "/dashboard/" }}>
          <Logo simple height="26" />
        </MobileNavItem>
        <MobileNavItem href={{ pathname: "/dashboard/companies/overview" }}>
          <HiOutlineCollection size={24} color="currentColor" />
        </MobileNavItem>
        <MobileNavItem href={{ pathname: "/dashboard/attribution/overview" }}>
          <HiOutlineFingerPrint size={24} color="currentColor" />
        </MobileNavItem>
        <MobileNavItem href={{ pathname: "/dashboard/account" }}>
          <HiOutlineUserCircle size={24} color="currentColor" />
        </MobileNavItem>
        <MobileNavItem href={{ pathname: "/dashboard/more" }}>
          <HiMenuAlt4 size={24} color="currentColor" />
        </MobileNavItem>
      </Box>
    </Box>
  )
}

function MobileNavItem({
  href,
  children,
}: {
  href: { pathname: string }
  children: React.ReactNode
}) {
  const router = useRouter()
  const active = router.pathname.startsWith(href.pathname)

  return (
    <Box
      component="li"
      sx={{
        color: "gray.600",
        width: "100%",
      }}
    >
      <Link href={href} passHref>
        <MuiLink
          sx={{
            color: active ? "primary.600" : "gray.600",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            py: 1,
          }}
        >
          {children}
        </MuiLink>
      </Link>
    </Box>
  )
}
